export default __webpack_public_path__ + "static/media/logo.1908a59e.png";